import React, { Fragment, useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import CircularWithPath from 'components/@extended/progress/CircularWithPath';

// material-ui
import { Box, Card, Grid, Stack, Typography } from '@mui/material';

import { useSelector } from 'react-redux';

// project imports
import moment from 'moment';
import useChatContext from 'hooks/useChatContext';
import MessageR, { DeleteMessageR, ReplyMessageR } from './MessageR';
import MessageL, { DeleteMessageL, ReplyMessageL } from './MessageL';

// ==============================|| CHAT MESSAGE HISTORY ||============================== //

const ChatHistory = ({ conversations, hasMore, setPageNumber }) => {
	const obj = useMemo(() => {
		const allConversation = {};
		let date;

		conversations.forEach((item) => {
			if (!date) {
				date = item?.time?.dateLong;
				allConversation[item?.time?.dateString] = [item];
			} else if (date === item?.time?.dateLong) {
				allConversation[item?.time?.dateString] = [...allConversation[item?.time?.dateString], item];
			} else if (date > item?.time?.dateLong) {
				date = item?.time?.dateLong;
				allConversation[item?.time?.dateString] = [item];
			} else if (date < item?.time?.dateLong) {
				date = item?.time?.dateLong;
				allConversation[item?.time?.dateString] = [item];
			}
		});
		return allConversation;
	}, [conversations]);

	const findMessageDelete = (history) => {
		conversations.forEach((conversation) => {
			if (conversation.id === history.replyId && conversation.type === 'DELETE') {
				return null;
			}
		});

		return history?.replyMessage?.message;
	};

	return (
		<Box id="scrollableDiv" sx={{ flex: '1 1 0', order: 2, overflowY: 'auto', display: 'flex', flexDirection: 'column-reverse' }}>
			<InfiniteScroll
				dataLength={conversations.length}
				next={() => {
					setPageNumber((prev) => prev + 1);
				}}
				hasMore={hasMore}
				loader={
					<Box sx={{ position: 'absolute', top: 10, left: 0, width: '100%' }}>
						<Stack width="100%" alignItems="center" justifyContent="center">
							<CircularWithPath size="medium" />
						</Stack>
					</Box>
				}
				style={{ display: 'flex', flexDirection: 'column-reverse', overflow: 'visible', margin: '0 32px 8px 32px', position: 'relative' }}
				scrollableTarget="scrollableDiv"
				inverse={true}
			>
				{Object.keys(obj).map((key, indexObj) => {
					return (
						<Fragment key={indexObj}>
							{obj[key].map((history, index) => {
								return <ConversationCard key={index} history={history} findMessageDelete={findMessageDelete} />;
							})}

							<Grid item xs={12} sx={{ py: 1.5 }}>
								<Stack direction="row" alignItems="center" justifyContent="center">
									<Card
										sx={{
											bgcolor: '#f2f2f2',
											color: '#5c5c5c',
											boxShadow: 'none',
											py: 1,
											px: 2,
											borderRadius: '10px',
										}}
									>
										<Typography variant="h6" component="p" textAlign="center">
											{moment(key).calendar(null, {
												sameDay: '[Today]',
												lastDay: '[Yesterday]',
												lastWeek: 'dddd [,] D MMM YYYY',
												sameElse: 'dddd [,] D MMM YYYY',
											})}
										</Typography>
									</Card>
								</Stack>
							</Grid>
						</Fragment>
					);
				})}
				{hasMore && <Box sx={{ width: '100%', height: '30px' }}></Box>}
			</InfiniteScroll>
		</Box>
	);
};

export default ChatHistory;

const ConversationCard = ({ history, findMessageDelete }) => {
	const { selectedUser } = useChatContext();
	const userId = useSelector((state) => state.auth.userId);

	// **************************
	// *********RIGHT************
	// **************************

	if (history?.senderId === userId) {
		if (history?.type === 'DELETE') {
			return (
				<DeleteMessageR
					// key={Math.random()}
					date={history?.time?.localDateTime}
				/>
			);
		} else if (history?.replyId) {
			return (
				<ReplyMessageR
					// key={Math.random()}
					message={history?.message}
					date={history?.time?.localDateTime}
					msgObj={history}
					replyObj={history?.replyMessage}
					replyUserName={history?.replyMessage?.senderId === selectedUser?.otherUserId ? selectedUser?.entityFullName : 'You'}
					replyMessage={findMessageDelete(history) ?? 'This message was deleted.'}
					isSameUser={true}
				/>
			);
		} else if (history?.attachmentType === 'type/file') {
			return (
				<MessageR
					// key={Math.random()}
					message={history?.message}
					date={history?.time?.localDateTime}
					msgObj={history}
					file={history?.attachment}
					isSameUser={true}
				/>
			);
		} else if (history?.attachmentType === 'type/image') {
			return (
				<MessageR
					// key={Math.random()}
					message={history?.message}
					date={history?.time?.localDateTime}
					msgObj={history}
					image={history?.attachment}
					isSameUser={true}
				/>
			);
		} else {
			return (
				<MessageR
					// key={Math.random()}
					message={history?.message}
					date={history?.time?.localDateTime}
					reply={history?.replyMessage}
					msgObj={history}
					isSameUser={true}
				/>
			);
		}
	}
	// **************************
	// *********LEFT*************
	// **************************
	if (history?.senderId !== userId) {
		if (history?.type === 'DELETE') {
			return (
				<DeleteMessageL
					// key={Math.random()}
					date={history?.time?.localDateTime}
					isSameUser={true}
					userId={history?.senderId}
				/>
			);
		} else if (history?.replyId) {
			return (
				<ReplyMessageL
					// key={Math.random()}
					message={history?.message}
					date={history?.time?.localDateTime}
					msgObj={history}
					reply={history?.replyMessage}
					replyUserName={history?.replyMessage?.senderId === selectedUser?.otherUserId ? selectedUser?.entityFullName : 'You'}
					replyMessage={findMessageDelete(history) ?? 'This message was deleted.'}
					isSameUser={true}
					userId={history?.senderId}
				/>
			);
		} else if (history?.attachmentType === 'type/file') {
			return (
				<MessageL
					// key={Math.random()}
					message={history?.message}
					date={history?.time?.localDateTime}
					msgObj={history}
					file={history?.attachment}
					isSameUser={true}
					userId={history?.senderId}
				/>
			);
		} else if (history?.attachmentType === 'type/image') {
			return (
				<MessageL
					// key={Math.random()}
					message={history?.message}
					date={history?.time?.localDateTime}
					msgObj={history}
					image={history?.attachment}
					isSameUser={true}
					userId={history?.senderId}
				/>
			);
		} else {
			return (
				<MessageL
					// key={Math.random()}
					message={history?.message}
					date={history?.time?.localDateTime}
					msgObj={history}
					reply={history?.replyMessage}
					isSameUser={true}
					userId={history?.senderId}
				/>
			);
		}
	}

	return null;
};
